const YOUTUBE_HOSTS = new Set(["youtube.com", "www.youtube.com", "m.youtube.com", "youtu.be"]);
const OTHER_EMBED_HOSTS = new Set(["cc.sporttube.com", "sporttube.com", "www.sporttube.com"]);

function getYouTubeVideoId(videoUrl: string | null | undefined) {
  if (!videoUrl) return null;
  try {
    const url = new URL(videoUrl);
    if (!YOUTUBE_HOSTS.has(url.hostname)) return null;
    if (url.hostname === "youtu.be") return url.pathname.slice(1).split("/")[0] || null;
    return url.searchParams.get("v") || url.pathname.match(/\/(?:shorts|embed)\/([^/]+)/)?.[1] || null;
  } catch {
    return null;
  }
}

export function getYouTubeEmbedUrl(videoUrl: string | null | undefined) {
  const id = getYouTubeVideoId(videoUrl);
  return id ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0` : null;
}

export function isYouTubeVideoUrl(videoUrl: string | null | undefined) {
  if (!videoUrl) return false;
  try {
    const url = new URL(videoUrl);
    return YOUTUBE_HOSTS.has(url.hostname) && Boolean(getYouTubeVideoId(videoUrl));
  } catch {
    return false;
  }
}

export function getEmbeddableVideoUrl(videoUrl: string | null | undefined) {
  const youtubeUrl = getYouTubeEmbedUrl(videoUrl);
  if (youtubeUrl) return youtubeUrl;
  if (!videoUrl) return null;
  try {
    const url = new URL(videoUrl);
    if (OTHER_EMBED_HOSTS.has(url.hostname) && url.pathname.startsWith("/embed/")) return url.toString();
  } catch {
    return null;
  }
  return null;
}
